import { apiClient } from "../config";

async function getExifData(id: number) {
  const res = await apiClient.get(`/admin/file/${id}/exif`)
  return res.data;
}

export default getExifData;
